<template>
  <b-row>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.exsbwarehouses.list.type') }}:</label>
        <el-select
          class="select-default"
          v-model.lazy="filters.idClientType"
          v-debounce="delay">
          <el-option
            class="select-default"
            v-for="item in clientTypes"
            :key="item['@id']"
            :label="item.title"
            :value="item['@id']">
          </el-option>
        </el-select>
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.firmname1') }}:</label>
        <input v-model.lazy="filters.firmname1" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.show.firmDepartment.firmname2') }}:</label>
        <input v-model.lazy="filters.firmname2" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.userdata.form.name') }}:</label>
        <input v-model.lazy="filters.name" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.userdata.form.surname') }}:</label>
        <input v-model.lazy="filters.surname" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.country') }}:</label>
        <input v-model.lazy="filters.country" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.postcode') }}:</label>
        <input v-model.lazy="filters.postcode" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.city') }}:</label>
        <input v-model.lazy="filters.city" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.street') }}:</label>
        <input v-model.lazy="filters.street" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.nip') }}:</label>
        <input v-model.lazy="filters.nip" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.tags') }}:</label>
        <multi-select @select="onSelectTag" :options="tagOptions" :selected-options="tagsFilter"></multi-select>
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.withoutTags') }}:</label>
        <multi-select @select="onSelectWithoutTag" :options="tagOptions" :selected-options="withoutTagsFilter"></multi-select>
      </div>
    </b-col>
    <b-col v-if="opportunityOptions.length > 0" cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.idOpportunity') }}:</label>
        <multi-select @select="onSelectOpportunity" :options="opportunityOptions" :selected-options="opportunityFilter"></multi-select>
      </div>
    </b-col>
    <b-col v-if="statusOptions.length > 0" cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.idStatus') }}:</label>
        <multi-select @select="onSelectStatus" :options="statusOptions" :selected-options="statusFilter"></multi-select>
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <label class="form-control-label">{{ $t('views.userdata.list.filters.userdata') }}:</label>
      <input v-model.lazy="filters.userdata" v-debounce="delay" class="form-control" type="text" placeholder="">
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
        <b-form-group>
          <b-form-radio-group
            v-model="filters.state"
            :options="radioOptions"
            buttons
            button-variant="outline-primary"
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import { MultiSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { getUserRoles } from '@/utils/checkRoles'

export default {
  name: 'FirmFiltering',
  components: { MultiSelect },
  data () {
    return {
      lastSelectItem: {},
      lastSelectItemOpportunity: {},
      lastSelectItemStatus: {},
      tags: [],
      tagOptions: [],
      statusOptions: [],
      opportunityOptions: [],
      clientTypes: [],
      radioOptions: [{ value: 1, text: this.$t('buttons.no') }, { value: 0, text: this.$t('buttons.yes') }],
      delay: 500,
      filters: this.$store.state.filters.firmFilter,
      statuses: [],
      tagsFilter: [],
      withoutTagsFilter: [],
      opportunityFilter: [],
      statusFilter: [],
      loading: false
    }
  },

  computed: {
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    }
  },
  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.filter()
      }
    }
  },
  created () {
    this.getClientTypes()
    this.fetchTagOptions()
    this.fetchStatuses()
    this.fetchSalesOpportunities()
  },
  methods: {
    filter () {
      this.$store.state.filters.firmFilterCurrentPage = 1
      let params = Object.assign({}, this.filters)
      let link = addParamsToQuery(`user_datas`, params)
      this.getPage(link)
    },
    clearFilter () {
      this.filters = Object.assign(this.filters, this.$store.state.filters.firmFilterReference)
    },
    getPage (url) {
      this.$emit('getPage', url)
    },
    onSelectTag (items, lastSelectItem) {
      this.tagsFilter = items
      this.filters['userDataTags.idTag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    onSelectWithoutTag (items, lastSelectItem) {
      this.withoutTagsFilter = items
      this.filters['userDataWithoutTag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    onSelectOpportunity (items, lastSelectItem) {
      this.opportunityFilter = items
      this.filters.salesOpportunity = items.map(item => {
        return item.value
      })
      this.lastSelectItemOpportunity = lastSelectItem
    },
    onSelectStatus (items, lastSelectItem) {
      this.statusFilter = items
      this.filters.status = items.map(item => {
        return item.value
      })
      this.lastSelectItemStatus = lastSelectItem
    },
    async fetchTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.tagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    async fetchSalesOpportunities () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_sales_opportunities', params).getResults()
      this.opportunityOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async fetchStatuses () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_statuses', params).getResults()
      this.statusOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async getClientTypes () {
      const response = await new ApiService('client_types', { pagination: false }).getResults()
      this.clientTypes = response.items.map(entry => {
        return {
          '@id': getIdFromLink(entry['@id']),
          title: entry.title
        }
      }).filter(entry => {
        return entry.title === 'Klient' || entry.title === 'Firma' || (entry.title === 'Hurtownia' && !this.isWholesaler)
      })
      // this.filters.clientType = this.clientTypes[0]['@id']
    }
  }
}
</script>
